import React from 'react';
import { useHistory } from 'react-router';
import { withTranslation } from 'react-i18next';
import helper from '../../../../utils/helper';
import Footer from '../../../Helpers/Footer';
import Moment from 'moment';
import AckAlarm from '../AckAlarm';
import { DialogBox } from '../../../UI/Modal';

function MobileActionMenu({ alarm, t, ...props }) {
  const [ackAlarmProps, setAckAlarmProps] = React.useState({
    isOpen: false,
    sensorIds: [],
    sensorName: '',
  });
  const [ableToAck, setAbleToAck] = React.useState(false);
  const [declineMsgVisibility, openDeclineMsg] = React.useState(false);

  React.useEffect(() => {
    for (let index = 0; index < alarm.length; index++) {
      if (alarm[index].ackEnable) {
        setAbleToAck(true);
      } else {
        setAbleToAck(false);
        return;
      }
    }
  }, [alarm]);
  const sensorIds = alarm.map((al) => al.sensorId);
  function getTrendChartDefaultPeriodHours() {
    const trendChartDefaultPeriodHours = helper.getSetting(
      'TrendChartDefaultPeriodHours',
    );
    return parseInt(trendChartDefaultPeriodHours.value);
  }
  const locale = localStorage.getItem('language') || 'en_US';
  const history = useHistory();
  function ackAlarm() {
    if (ableToAck) {
      setAckAlarmProps({
        isOpen: true,
        sensorIds: sensorIds,
        sensorName: alarm.name,
      });
    } else {
      openDeclineMsg(true);
    }
  }
  function showTrendChart() {
    const hours = getTrendChartDefaultPeriodHours();
    const toDate = Moment().format('MM/DD/yyyy HH:mm:ss');
    const fromDate = Moment()
      .subtract(hours, 'hours')
      .format('MM/DD/yyyy HH:mm:ss');
    history.push(
      `/trend-charts?sensorIds=${sensorIds.join(
        ',',
      )}&fromDate=${fromDate}&toDate=${toDate}&locale=${locale}`,
    );
  }
  return (
    <div className="page-inner">
      <div className="main">
        <div
          className="page-title d-flex align-items-center"
          style={{ paddingLeft: 15 }}
        >
          <div
            onClick={props.onBack}
            className="d-flex align-items-center mr-10"
          >
            <i className="md-icon">arrow_back</i>
          </div>
          <h1>{alarm.name}</h1>
        </div>

        <div className="content">
          <div
            style={{ display: 'flex', flexDirection: 'column', width: '100%' }}
          >
            <Item name="Ack Alarm" onClick={ackAlarm} />
            <AckAlarm
              {...ackAlarmProps}
              t={t}
              onCancel={() => setAckAlarmProps({ isOpen: false })}
              onAdd={() => {
                setAckAlarmProps({ isOpen: false });
              }}
            />

            <DialogBox
              isOpen={declineMsgVisibility}
              title="Oops"
              body="Acking cannot be completed due to the ineligible sensors"
              onYes={() => openDeclineMsg(false)}
            />
            <Item name="Show Trend Chart" onClick={showTrendChart} />
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}

function Item(props) {
  return (
    <div
      className="d-flex align-items-center justify-content-between"
      style={{ padding: '5px 10px', borderBottom: '1px solid grey' }}
      onClick={props.onClick}
    >
      <h4>{props.name}</h4>
      <i className="md-icon">arrow_forward</i>
    </div>
  );
}

export default withTranslation('app')(MobileActionMenu);
